import { css } from '@emotion/react';
export const suggestionsContainerStyles = css({
  width: '100%',
  height: '100%',
  margin: '0px',
  padding: '0px',
  listStyle: 'none',
  display: 'inline-block',
  position: 'relative',
  'li:first-of-type': {
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit'
  },
  'li:last-of-type': {
    borderBottomLeftRadius: 'inherit',
    borderBottomRightRadius: 'inherit'
  }
});
export const suggestionButtonStyles = css({
  width: '100%',
  minHeight: '40px',
  padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
  marginTop: '0px',
  border: 0,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'start',
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  gap: '13px',
  textAlign: 'left',
  fontWeight: 400,
  lineHeight: '18px',
  color: "var(--ds-text, #172b4d)",
  fontFamily: 'inherit',
  fontSize: 'inherit',
  background: 'none',
  '&:not([disabled])': {
    cursor: 'pointer',
    '&:active': {
      backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    "&[data-highlighted='true']": {
      '&:not(:active)': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
      }
    },
    '&:focus': {
      outline: `2px solid ${"var(--ds-border-focused, #4C9AFF)"}`,
      outlineOffset: "var(--ds-space-negative-025, -2px)"
    }
  },
  '&[disabled]': {
    background: "var(--ds-background-disabled, #091e420a)",
    color: "var(--ds-text-disabled, #A5ADBA)",
    cursor: 'not-allowed'
  }
});
export const enterIconStyles = css({
  // with '&', the following selector applies only if this icon style is under a highlighted button
  "button[data-highlighted='true'] &": {
    display: 'inline'
  },
  display: 'none',
  padding: '5px 5px 3px 5px',
  borderRadius: '3px',
  color: "var(--ds-text-subtle, #44546F)",
  backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
});
export const suggestionListItemStyles = css({
  marginTop: '0px',
  listStyle: 'none'
});
export const suggestionLabelStyles = css({
  hyphens: 'auto',
  wordWrap: 'break-word',
  flex: 1,
  minWidth: '90px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
});
export const suggestionDescriptionStyles = css({
  hyphens: 'auto',
  wordWrap: 'break-word',
  flex: 1,
  minWidth: '90px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  fontSize: '12px',
  lineHeight: '16px',
  color: "var(--ds-text-subtlest, #626F86)",
  paddingTop: "var(--ds-space-050, 4px)",
  display: 'inline-block'
});
export const tellAILabelStyles = css({
  fontWeight: 500
});
export const suggestionsHeadingStyles = css({
  '&&': {
    margin: '0px',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: "var(--ds-text-subtle, #42526E)"
  }
});
export const suggestionsGroupHeadingStyles = css({
  margin: '0px',
  padding: `${"var(--ds-space-075, 18px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
  '& h3': {
    margin: 0,
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: "var(--ds-text-subtle, #42526E)"
  }
});
export const suggestionIconStyles = css({
  height: '24px',
  width: '24px',
  textAlign: 'center',
  // Increase the size of default icon a little so it looks better
  '& > .default-icon': {
    height: '20px',
    width: '20px'
  }
});
export const suggestionsScrollerStyles = css({
  maxHeight: '144px',
  overflowY: 'auto'
});